import store from '@/store'
import ApiClient from '@/plugins/AxiosPlugin'
export default class AddToCartHelper {
    static store = store

    static addToCart(codeOptions, currentTab, buttonPressed) {
        if (codeOptions.length > 0) {

            var previousMaterialList = JSON.parse(localStorage.getItem('materialList'))
            var isMultiPO = Array.isArray(previousMaterialList) && !!previousMaterialList[0]?.isMultiPO

            var materialList = []
            codeOptions.forEach(function (value) {
                materialList.push({
                    code: value.code,
                    itemNo: value.itemNo,
                    isMarketOffer: false,
                    isMultiPO: isMultiPO
                })
            })
            localStorage.setItem(
                'materialList',
                JSON.stringify(materialList)
            )
            AddToCartHelper.addToCartTracking(materialList, currentTab, buttonPressed)

            AddToCartHelper.redirectToDrawer();
        }
    }

    static redirectToDrawer() {
        var drawerURL = location.href.split('com')[0] + 'com/'+ store.state.browser.languageCode +'/drawer.html'
        location.href = drawerURL
    }

    static addToCartTracking(materialList, currentTab, buttonPressed) {
        var items = store.state.myAccountItems[currentTab]?.items ? store.state.myAccountItems[currentTab].items : [] 
        var productName = store.state.product.productAttributes?.[0]?.productName

        var products = materialList.map((value) => {
            var item
            if (items)
                item = items.find((x) => x.dowMaterialNumber === value.code)

            let addMethod;
            switch(currentTab) {
                case 'favoriteBuyingOptions': 
                    if(buttonPressed === 'addToCart'){
                        addMethod = 'favorite_buying_options_add_to_cart';
                    } else if(buttonPressed === 'checkAvailability'){
                        addMethod = 'favorite_buying_options_check_availability';
                    } else{
                        addMethod = 'Favorite Buying Options';
                    }
                    break;
                case 'myPartNumbers':
                    if(buttonPressed === 'addToCart'){
                        addMethod = 'my_part_numbers_add_to_cart';
                    } else if (buttonPressed === 'checkAvailability') {
                        addMethod = 'my_part_numbers_check_availability';
                    } else {
                        addMethod = 'My Part Numbers';
                    }
                    break;
                case 'previousPurchases':
                    if(buttonPressed === 'addToCart'){
                        addMethod = 'previous_purchases_add_to_cart';
                    } else if (buttonPressed === 'checkAvailability') {
                        addMethod = 'previous_purchases_check_availability';
                    } else {
                        addMethod = 'Previous Purchases';
                    }
                    break;
                case 'quick-add' : addMethod = 'Quick Add'; break;
                default: addMethod = 'unavailable'; break;
            }

            return {
                SKU: value.code || 'unavailable',
                gmid: value.code || 'unavailable',
                name: item && item.dowMaterialName ? item.dowMaterialName : (productName ? productName : '' || 'unavailable'),
                productAddMethod: addMethod
            }
        })

        if (products.length > 0)
            store.dispatch('assets/addToCartTracking', {
                step: 'step1',
                products: products
            })
    }

    static addMaterialToCart(materialNo, currentTab='noTab'){
        let codeOptions = [{
            code: materialNo,
            option: 'buy'
        }]
        this.addToCart(codeOptions, currentTab)
    }
}
